import { ColorPalette } from './colors/colorPalette'
import { TextStyles } from './textStyles/defaultTextStyles'

// ThemeConfig was renamed to ThemingConfig in Chakra v3
// For now, we'll define a minimal type for backward compatibility
type ThemeConfig = {
  initialColorMode?: 'light' | 'dark'
  useSystemColorMode?: boolean
}

export enum ThemeColorMode {
  default = 'light',
  dark = 'dark',
}

// Type for semantic token values that support dark mode
export type SemanticTokenValue = {
  default: string
  _dark: string
}

// Type for color-specific semantic tokens (brand, blue, red, green, orange, gray)
export interface ColorSemanticTokens {
  solid: SemanticTokenValue
  emphasized: SemanticTokenValue
  subtle: SemanticTokenValue
  muted: SemanticTokenValue
  fg: SemanticTokenValue
  contrast: SemanticTokenValue
  focusRing: SemanticTokenValue
}

export type MangoTheme = {
  breakpoints: Record<string, string>
  textStyles: TextStyles
  colors: ColorPalette
  config?: ThemeConfig
}

export type SemanticTokens = {
  colors: {
    // NEW CHAKRA V3 SEMANTIC TOKENS
    // Background tokens
    bg: {
      default: SemanticTokenValue
      subtle: SemanticTokenValue
      muted: SemanticTokenValue
      emphasized: SemanticTokenValue
      panel: SemanticTokenValue
      inverted: SemanticTokenValue
      overlay: SemanticTokenValue
      solid: SemanticTokenValue
      error: SemanticTokenValue
      warning: SemanticTokenValue
      success: SemanticTokenValue
      info: SemanticTokenValue
    }
    // Foreground/text tokens
    fg: {
      default: SemanticTokenValue
      subtle: SemanticTokenValue
      muted: SemanticTokenValue
      emphasized: SemanticTokenValue
      inverted: SemanticTokenValue
      info: SemanticTokenValue
      error: SemanticTokenValue
      warning: SemanticTokenValue
      success: SemanticTokenValue
    }
    // Border tokens
    border: {
      default: SemanticTokenValue
      subtle: SemanticTokenValue
      muted: SemanticTokenValue
      emphasized: SemanticTokenValue
      inverted: SemanticTokenValue
      error: SemanticTokenValue
      warning: SemanticTokenValue
      success: SemanticTokenValue
      info: SemanticTokenValue
    }
    // Brand and color-specific tokens
    brand: ColorSemanticTokens
    blue: ColorSemanticTokens
    red: ColorSemanticTokens
    green: ColorSemanticTokens
    orange: ColorSemanticTokens
    gray: ColorSemanticTokens
  }
}
